import PropTypes from 'prop-types'
import React, { Component } from 'react'
import './Avatar.css'

class Avatar extends Component {
  constructor () {
    super()
    this.state = {}
  }

  render () {
    const { color, size, initials } = this.props
    const px = `${size}px`
    const styles = {
      width: px,
      height: px,
      borderRadius: px,
      lineHeight: px
    }

    return (
      <div className='ui-Avatar' color={color} style={styles}>
        {this.renderImage()}
        <div className='ui-Avatar-fallback' style={styles}>
          <span>{initials}</span>
        </div>
      </div>
    )
  }

  renderImage () {
    const { size, shouldHideImage, url } = this.props

    if (this.state.shouldHideImage || shouldHideImage) return

    return (
      <img
        className='ui-Avatar-image'
        src={url}
        height={size}
        width={size}
        style={{ borderRadius: `${size}px` }}
        onError={() => this.setState({ shouldHideImage: true })} />
    )
  }
}

Avatar.defaultProps = {
  size: 40,
  color: 'green'
}

Avatar.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  url: PropTypes.string,
  initials: PropTypes.string,
  shouldHideImage: PropTypes.bool
}

Avatar.displayName = 'Avatar'

export default Avatar



// WEBPACK FOOTER //
// ./ui/Avatar.js